module.exports = __webpack_public_path__ + "static/media/google_amazon_en.483faf04.png";